import React, { useState } from "react";
import { Col, Container, Row, Card, CardBody } from "reactstrap";
import { H3, H2, P } from "../../AbstractElements";
import DocumentsDetails from "./DocumentsDetails";
import VideosDetails from "./VideosDetails";
const Help = () => {
  const documents = "Documents";
  const videos = "Videos";
  const [helpType, setHelpType] = useState(null);
  return (
    <Container fluid={true}>
      <div className="page-title">
        <Row>
          <Col xs="12">
            {!helpType && helpType == null ? (
              <div className="previous-page">
                <H3>{"Help"}</H3>
              </div>
            ) : (
              <div className="previous-page" onClick={() => setHelpType(null)}>
                <i className="fa fa-angle-left"></i>
                <H3>{"Help"}</H3>
              </div>
            )}
          </Col>
        </Row>
      </div>
      {!helpType && helpType == null ? (
        <div className="help-body">
          <Card onClick={() => setHelpType(documents)} className="help-card">
            <CardBody>
              <H2>Documents</H2>
            </CardBody>
          </Card>
          <Card onClick={() => setHelpType(videos)} className="help-card">
            <CardBody>
              <H2>Videos</H2>
            </CardBody>
          </Card>
        </div>
      ) : helpType == documents ? (
        <DocumentsDetails />
      ) : (
        <VideosDetails />
      )}
    </Container>
  );
};

export default Help;
